class SessionClass {
  getUser(value: any) {
    return JSON.parse(sessionStorage.getItem(value) || '{}');
  }
  setUser(value: string, user: any) {
    return sessionStorage.setItem(value, JSON.stringify(user));
  }
}

export default SessionClass;
